<template>
	<nav class="side-nav">
		
		<div class="filter" v-if="!index">
			<input type="text" placeholder="Filter" v-model="filterText" />
		</div>
		
		<ul class="items">
			<li class="heading">{{ title }}</li>
			<li v-for="(chunk, i) in navTreeFilter" :key="i" :class="[ chunk.class, { active: chunk.id == itemInView, 'active-parent': childActive(i), } ]">
				<a :href="chunk.link">
					{{ chunk.text }}
				</a>
			</li>
		</ul>
		
		<ul class="items" v-if="childArticlesFilter">
			<li class="heading" v-for="child in childArticlesFilter" :key="child.id">
				<router-link :to="{ path: 'article-view', query: { id: child.id } }">
					{{ child.title }}
				</router-link>
			</li>
		</ul>
		
	</nav>
</template>

<script>
export default {
	name: "SideNavigation",
	props: ["articleJson", "title", "index", "articleId", "itemInView"],
	data: function () {
		return {
			navTree: [],
			navTreeFilter: [],
			childArticlesFilter: [],
			filterText: "",
		};
	},
	methods: {
		calcNav: function () {
			if (!this.articleJson) return;
			
			let arr = this.articleJson.content;
			if (!arr) return;
			
			for (let i = 0; i < arr.length; i++) {
				const el = arr[i];
				if (el && el.type === "heading") {
					this.navTree.push({
						class: "item-h" + el.attrs.level,
						text: el.content ? el.content[0].text : "",
						link: "#" + el.attrs.id,
						id: el.attrs.id,
						level: el.attrs.level,
					});
				}
			}
			this.navTreeFilter = this.navTree;
		},
		childActive: function (i) {
			let arr = this.navTree.slice(i + 1);
			let children = [];
			for (let i = 0; i < arr.length; i++) {
				if (arr[i] && arr[i].level == 3) {
					children.push(arr[i]);
				} else {
					break;
				}
			}
			if (children.length == 0) return;
			return (
			children.some((e) => e.id == this.itemInView) &&
			this.navTree[i].level == 2
			);
		},
	},
	watch: {
		articleJson: function () {
			this.navTree = [];
			this.calcNav();
		},
		filterText: function () {
			if (this.navTree) {
				if (this.filterText.length === 0) {
					this.navTreeFilter = this.navTree;
				}
				this.navTreeFilter = this.navTree.filter((n) =>
				n.text.toLowerCase().includes(this.filterText.toLowerCase())
				);
			}
			if (this.treeArticle && this.treeArticle.children) {
				if (this.filterText.length === 0) {
					this.childArticlesFilter = this.treeArticle.children;
				}
				this.childArticlesFilter = this.treeArticle.children.filter(
				(n) =>
				n.title
				.toLowerCase()
				.includes(this.filterText.toLowerCase())
				);
			}
		},
		treeArticle: function () {
			if (this.treeArticle) {
				this.childArticlesFilter = this.treeArticle.children;
			}
		},
	},
	computed: {
		treeArticle: function () {
			return this.$store.getters.treeArticle(this.articleId);
		},
	},
};
</script>

<style scss scoped>

.side-nav {
	flex: 1 0 auto;
	padding: 1em;
	height: 100%;
	overflow: auto;
	
	.filter {
		display: flex;
		position: relative;
		align-items: center;
		
		input {
			width: 100%;
			padding: 0.5rem 1rem 0.5rem 3rem;
			border: 1px solid #ddd;
			border-radius: 0.3em;
			outline: none;
			
			&:focus {
				box-shadow: 2px 2px 0px rgba(0, 0, 0, 0.2),
				inset 0px 0px 0px rgba(0, 0, 0, 0);
			}
		}
	}
	
	.items {
		list-style: none;
		padding: 1em 0;
		margin: 0;
		border-bottom: 1px solid #ededed;
		
		li {
			padding: 0.5em 0;
			
			&, a {
				display: block;
				color: var(--clr-neutral-shade-5, #808488);
			}
			
			&.heading {
				padding-left: 1rem;
				font-weight: bold;
			}
			
			&.item-h2 { padding-left: 2rem; }
			&.item-h3 { padding-left: 4rem; }
			&.item-h4 { padding-left: 6rem; }
			
			&.active {
				position: relative;
				
				a {
					display: flex;
					justify-content: space-between;
					color: var(--clr-accent-primary, #fea705);
					
					&::after {
						display: block;
						content: "<";
						color: var(--clr-accent-primary, #fea705);
					}
				}
			}
			
		}
	}
}

</style>